import * as React from 'react'

import { ToggleableSelect } from './toggleable-select'

import { IEpiProps, EpiProps } from '../models/epi-props'
import { IAAPAddress } from '../../global/models/aap-address';

interface IProps {
    contentId: string;
    addresses: IAAPAddress[];
}

interface IState {
    epiProps: IEpiProps
    selectedOption?: string
}

export class SubscriptionManagementPageApp extends React.Component<IProps, IState> {

    state = {
        epiProps: new EpiProps(),
        selectedOption: null
    }

    componentWillMount() {
        this.fetchEpiProps();
    }

    render() {

        const {
            shippingAddressLabel,
            selectAddressLabel,
            selectAddressPrompt,
            newAddressLabel,
            newAddressUrl,
            editLabel,
            cancelLabel,
            saveLabel
        } = this.state.epiProps;

        const options = this.props.addresses.map(address => ({
            key: address.AddressKey,
            value: `${address.AddressType} - ${address.Line1}`
        }));

        return (
            <div className="col-xxl-10 col-lg-9 col-md-10 col-sm-12">
                <ToggleableSelect
                    title={shippingAddressLabel}
                    selectLabel={selectAddressLabel}
                    selectPrompt={selectAddressPrompt}

                    editLabel={editLabel}
                    cancelLabel={cancelLabel}
                    saveLabel={saveLabel}

                    addNewLabel={newAddressLabel}
                    addNewUrl={newAddressUrl}

                    options={options}
                    selectedOption={this.state.selectedOption}

                    onOptionSaved={this.onShippingAddressSave} />
            </div>
        )
    }

    fetchEpiProps = () => {
        const contentId = (window as any).bootstrap.contentId;
        const url = `/api/v1/epi/properties?contentId=${contentId}`;
        fetch(url)
            .then(res => res.json())
            .then(json => this.setState({ epiProps: json.data }))
            .catch(err => console.warn(err));
    }

    onShippingAddressSave = (value: string): Promise<void> => {
        // It just works for now
        return new Promise(resolve => {
            this.setState({ selectedOption: value }, () => {
                resolve();
            })
        });
    }

}